
/**
 * Type guards for Supabase data validation
 */

export function isDatabaseRecord(value: any): value is Record<string, any> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function isDatabaseArray(value: any): value is Array<Record<string, any>> {
  return Array.isArray(value) && value.every(item => isDatabaseRecord(item));
}

export function isProfileData(value: any): value is any {
  return isDatabaseRecord(value) && typeof value.id === 'string';
}

export function isGroupData(value: any): value is any {
  return isDatabaseRecord(value) && typeof value.id === 'string' && typeof value.name === 'string';
}

export function toDatabaseValue(value: any): any {
  if (value === null || value === undefined) {
    return null;
  }
  
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  
  if (Array.isArray(value)) {
    return value.map(item => toDatabaseValue(item));
  }
  
  if (typeof value === 'object') {
    const result: Record<string, any> = {};
    for (const [key, val] of Object.entries(value)) {
      result[key] = toDatabaseValue(val);
    }
    return result;
  }
  
  return value;
}
